import axios from "axios";
import { API_HOST, ALT_DOMAIN_ID } from "@/core/variables";
import { IntentSentenceCreate, IntentSentenceUpdate, IntentSentenceUpdateAnswer } from "@/model";

class SentenceRepository {
    find = async (
        agentId: number,
        skillId: number,
        intentId: string
    ) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}/sentences`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    create = async (
        agentId: number,
        skillId: number,
        intentId: string,
        form: IntentSentenceCreate
    ) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}/sentences`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    update = async (
        agentId: number,
        skillId: number,
        intentId: string,
        sentenceKey: string,
        form: IntentSentenceUpdate
    ) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}/sentences/${sentenceKey}`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    updateAnswers = async (
        agentId: number,
        skillId: number,
        intentId: string,
        sentenceKey: string,
        body: IntentSentenceUpdateAnswer,
    ) => {
        const form: {[index: string]: string[]} = {};
        form[sentenceKey] = body.answers;

        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}/sentences/answers`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    delete = async (
        agentId: number,
        skillId: number,
        intentId: string,
        sentenceKey: string
    ) => {
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}/sentences/${sentenceKey}`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
}

const sentenceRepository = new SentenceRepository();
export default sentenceRepository;